import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeUserPasswordModalComponent } from 'src/app/shared/components/user/change-user-password-modal/change-user-password-modal.component';
import { IUser } from 'src/app/shared/interfaces/user/user.interface';
import { AccountStateService } from 'src/app/shared/services/account/account-state.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ClaimStatusRoutingStateService } from 'src/app/shared/services/claims-status-routing/claims-status-routing-state.service';
import { ClaimsStateService } from 'src/app/shared/services/claims/claims-state.service';
import { EligibilityRoutingStateService } from 'src/app/shared/services/eligibility-routing/eligibility-routing-state.service';
import { EraStateService } from 'src/app/shared/services/era/era-state.service';
import { GroupEnrollmentStateService } from 'src/app/shared/services/group-enrollment/insurance/group-enrollment-state.service';
import { InsuranceStateService } from 'src/app/shared/services/insurance/insurances-state.service';
import { PayersStateService } from 'src/app/shared/services/payers/payers-state.service';
import { ProviderGroupStateService } from 'src/app/shared/services/provider/provider-group-state.service';
import { ProviderStateService } from 'src/app/shared/services/provider/provider-state.service';
import { TokenExpireService } from 'src/app/shared/services/token-expire.service';
import { UserStateService } from 'src/app/shared/services/users/user-state.service';
import { DEFAULT_MODAL_OPTIONS } from 'src/app/shared/variables/variables';

import { UsersStateService } from '../../shared/services/users/users-state.service';

@Component({
  selector: 'app-dashboard-layout-component',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
  providers: [
    UsersStateService,
    AccountStateService,
    ClaimsStateService,
    EraStateService,
    GroupEnrollmentStateService,
    PayersStateService,
    InsuranceStateService,
    EligibilityRoutingStateService,
    ClaimStatusRoutingStateService,
    ProviderStateService,
    ProviderGroupStateService,
    TokenExpireService,
  ],
})
export class DashboardLayoutComponent implements OnInit {
  isLoading = true;
  baseDashboardUrl = '/dashboard/home';
  isBackLinkVisible: boolean;
  backLinkTitle: string;
  backLinkTitleFromQuery: string;
  user?: IUser;
  userInitials = '';
  isFullScreen = false;

  constructor(
    private userStateService: UserStateService,
    public router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private authService: AuthService,
    private modal: NgbModal,
    private tokenExpireService: TokenExpireService,
  ) {}

  ngOnInit() {
    this.isBackLinkVisible =
      this.router.url === this.baseDashboardUrl ? false : true;
    this.user = this.userStateService.user;
    this.userInitials = `${this.user?.firstName[0]}${this.user?.lastName ? this.user.lastName[0] : ''}`;
    this.tokenExpireService.setTokenExpirationWarning();

    this.route.queryParams.subscribe((params) => {
      this.backLinkTitleFromQuery = params.title;
      if (params.fullscreen === '1') {
        this.isFullScreen = true;
      }
    });

    if (this.route.firstChild) {
      this.route.firstChild.data.subscribe((data) => {
        if (data.title) {
          this.setBackLink(data.title as string, this.router.url);
        } else {
          this.setBackLink(this.backLinkTitleFromQuery, this.router.url);
        }
      });
    }

    this.router.events.subscribe((evt) => {
      if (
        evt instanceof RoutesRecognized &&
        evt.state.root.firstChild?.firstChild?.data.title
      ) {
        this.setBackLink(
          evt.state.root.firstChild.firstChild.data.title as string,
          evt.url,
        );
      }
    });
  }

  changeUserPassword() {
    const modal = this.modal.open(ChangeUserPasswordModalComponent, {
      ...DEFAULT_MODAL_OPTIONS,
      size: 'sm',
    });

    const { user } = this.userStateService;

    if (user) {
      (modal.componentInstance as ChangeUserPasswordModalComponent).userId =
        user.id;
    }
  }

  goBack() {
    this.location.back();
  }

  async logout() {
    await this.authService.logout();
  }

  async editProfile() {
    await this.router.navigate(['/dashboard/user']);
  }

  private setBackLink(title: string, url: string) {
    this.isBackLinkVisible = url === this.baseDashboardUrl ? false : true;
    if (this.isBackLinkVisible) {
      this.backLinkTitle = title;
    }
  }
}
